import { useDispatch } from 'react-redux';
import { headerClickEvent } from 'src/areas/product/actions/product';
import { showModal } from 'src/components/modal/actions';
import { PRODUCT_ALERT_MODAL_ID } from 'src/areas/product/constants';
import { ProductHeaderClickEventType } from 'src/areas/product/actions/types';
import { Media } from '../product-media/types';
import { ProductVideo } from 'src/types';

export const useOnAction = () => {
  const dispatch = useDispatch();

  return (type: ProductHeaderClickEventType) => {
    dispatch(headerClickEvent(type));
    if (type === 'alert-create') {
      dispatch(showModal(PRODUCT_ALERT_MODAL_ID));
    }
  };
};

type ProductMedia = {
  first?: string | null;
  images?: (string | null)[] | null;
  large?: (string | null)[] | null;
  videos?: (ProductVideo | null)[] | null;
};

export const getProductMedia = (media: ProductMedia): Media => {
  // Filters out null values in arrays
  return {
    ...media,
    images: media.images?.filter(item => item) as string[] | undefined,
    large: media.large?.filter(item => item) as string[] | undefined,
    videos: media.videos?.filter(item => item) as ProductVideo[] | undefined,
  };
};
